import { z } from "zod";

export const generateReviewSchema = z
  .object({
    selectedOptions: z.array(z.string()).min(1, "Please select at least one review option"),
    representingInput: z.string().optional(),
    considerationInput: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.selectedOptions.includes("custom-review")) {
        return data.considerationInput != null && data.considerationInput.trim().length > 0;
      }
      return true;
    },
    {
      message: "Please provide something to consider for custom review",
      path: ["considerationInput"],
    }
  );

export type GenerateReviewFormData = z.infer<typeof generateReviewSchema>;
